










































































































import Vue from "vue";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";
import AuthButtons from "@/components/AuthButtons.vue";

export default Vue.extend({
  name: "MainMenu",
  components: {
    AuthButtons
  },
  props: {
    toggleMenu: Boolean
  },
  data() {
    return {
      menuOpen: false,
      buyBookExpanded: false,
      adminExpanded: false,
      profileExpanded: false,
      currentUser: this.$authRepository.getCurrentUser(),
      RoleEnum
    };
  },
  watch: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
  }
});
